import { FC } from "react";
import { Button } from "@mui/material";
import { ButtonProps } from "./buttonType";
import ButtonComponentStyle from "./ButtonComponentStyle";

const ButtonComponent: FC<ButtonProps> = ({ sx, ...props }) => {
  const overloadCss = {
    ...ButtonComponentStyle.buttonSx,
    ...sx,
  };

  return (
    <Button
      disableRipple
      disableTouchRipple
      variant='contained'
      sx={overloadCss}
      fullWidth
      type={props?.type}
      {...props}
    >
      {props.text}
    </Button>
  );
};
export default ButtonComponent;
